import script from "./AppButtonSecond.vue?vue&type=script&setup=true&lang=js"
export * from "./AppButtonSecond.vue?vue&type=script&setup=true&lang=js"

import "./AppButtonSecond.vue?vue&type=style&index=0&id=70803d14&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70803d14"]])

export default __exports__